/**
 * Acciones DOLE sobre Viaje / Booking (RF-A1, RF-A3, RF-A5) y consulta del
 * log unificado (RF-LOG). Todas exigen motivo.
 */
const base = () => (process.env.REACT_APP_API_URL || '') + '/dole';

const headers = () => ({
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + (localStorage.getItem('jwt') || '').replaceAll('"', '')
});

const manejar = async (resp) => {
    const data = await resp.json().catch(() => ({}));
    if (!resp.ok) {
        throw new Error(data.error || 'No se pudo completar la acción');
    }
    return data;
};

/** RF-A1 - Anular viaje. La bitácora y el seguimiento se conservan. */
export const anularViaje = (viajeId, motivo, reactivarBooking) =>
    fetch(`${base()}/viaje/${viajeId}/anular`, {
        method: 'POST', headers: headers(),
        body: JSON.stringify({ motivo, reactivarBooking: !!reactivarBooking })
    }).then(manejar);

/** RF-A1 - Reactivar un viaje anulado. */
export const reactivarViaje = (viajeId, motivo) =>
    fetch(`${base()}/viaje/${viajeId}/reactivar`, {
        method: 'POST', headers: headers(), body: JSON.stringify({ motivo })
    }).then(manejar);

/** RF-A5 - Cambiar destino/planta: sincroniza booking y viaje en un solo evento. */
export const cambiarDestino = (viajeId, destino, motivo) =>
    fetch(`${base()}/viaje/${viajeId}/cambiar-destino`, {
        method: 'POST', headers: headers(), body: JSON.stringify({ destino, motivo })
    }).then(manejar);

/** RF-C2 - Cargar o corregir la ATA BNP (queda como etapa del viaje + log). */
export const guardarAtaBnp = (viajeId, ataBnp, motivo) =>
    fetch(`${base()}/viaje/${viajeId}/ata-bnp`, {
        method: 'POST', headers: headers(), body: JSON.stringify({ ataBnp, motivo })
    }).then(manejar);

/** RF-A10 - Encolar el reproceso de un viaje. etapas: array (cerrar/patio_seco/candado/eta_ata/estado). */
export const reprocesarViaje = (viajeId, etapas, motivo) =>
    fetch(`${base()}/viaje/${viajeId}/reprocesar`, {
        method: 'POST', headers: headers(), body: JSON.stringify({ etapas, motivo })
    }).then(manejar);

/** RF-A10 - Estado del último reproceso del viaje (para el badge / polling). */
export const reprocesoEstado = (viajeId) =>
    fetch(`${base()}/viaje/${viajeId}/reproceso-estado`, { headers: headers() }).then(manejar);

/** Recorrido del viaje en mapa: trayectoria (puntos) + destino + radio de llegada. */
export const recorridoViaje = (viajeId) =>
    fetch(`${base()}/viaje/${viajeId}/recorrido`, { headers: headers() }).then(manejar);

/** RF-LOG - Historial de un viaje. */
export const logViaje = (viajeId) =>
    fetch(`${base()}/viaje/${viajeId}/log`, { headers: headers() }).then(manejar);

/** RF-LOG - Historial del booking + el de sus viajes. */
export const logBooking = (bookingId) =>
    fetch(`${base()}/booking/${bookingId}/log`, { headers: headers() }).then(manejar);

/** Cancelar un booking sin viaje (queda 'Anulado' -> sale del total No Despachado). Reversible. */
export const cancelarBooking = (bookingId, motivo) =>
    fetch(`${base()}/booking/${bookingId}/cancelar`, {
        method: 'POST', headers: headers(), body: JSON.stringify({ motivo })
    }).then(manejar);

/** Reactivar un booking anulado (vuelve a 'Activo' -> disponible de nuevo). */
export const reactivarBooking = (bookingId, motivo) =>
    fetch(`${base()}/booking/${bookingId}/reactivar`, {
        method: 'POST', headers: headers(), body: JSON.stringify({ motivo })
    }).then(manejar);

/**
 * Control de tramos (DOLE 31/10/2026): R9/R11 -> patio seco y R11 -> R9 solo chasis, con sus conteos.
 * Con los filtros de arriba de Logistica (03/11/2026): año, mes, semana y día del booking (-1 = todos).
 */
export const controlTramos = (anio, mes, semana, diaSemana, circuito) =>
    fetch(`${base()}/control-tramos?anio=${anio}&mes=${mes}&semana=${semana}&diaSemana=${diaSemana}&circuito=${circuito || 'TODOS'}`,
        { headers: headers() }).then(manejar);
